import React from 'react'
import {Heading, FontWeight, HeadingElement} from '@influxdata/clockface'

interface Props {
  text: string
}

const FunnelSubheader = ({text}: Props): JSX.Element => (
  <Heading
    element={HeadingElement.P}
    weight={FontWeight.Medium}
    className="cf-funnel-page--subtitle"
  >
    {text}
  </Heading>
)

export default FunnelSubheader
